// DS: i4.29
import React from 'react';
import IconWrap from '../../IconWrap';
const SubmitPostJournal = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M20 3a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h16zm-1 2H5v14h14V5zm-4 6a1 1 0 011 1v4a1 1 0 01-1 1H9a1 1 0 01-1-1v-4a1 1 0 011-1h6zm1-4a1 1 0 010 2H8a1 1 0 110-2h8z"
    })));
SubmitPostJournal.displayName = 'SubmitPostJournal';
export default SubmitPostJournal;

//# sourceMappingURL=SubmitPostJournal.js.map